import { HttpErrorResponse } from '@angular/common/http'
import { Params } from '@angular/router'
import { Update } from '@ngrx/entity'
import { Action, createAction, props } from '@ngrx/store'
import { SlimItemEntity, PopperPayload } from './items.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'

export const loadItems = createAction('[Item/API] Load Items')

export const loadItemsSuccess = createAction('[Item/API] Load Items Success', props<{ items: SlimItemEntity[] }>())

export const loadFilteredItems = createAction('[Item/API] Load Filtered Items', props<{ filters: Params }>())

export const loadFilteredItemsSuccess = createAction(
  '[Item/API] Load Filtered Items Success',
  props<{ items: SlimItemEntity[] }>(),
)

export const loadFilteredItemsFailure = createAction(
  '[Item/API] Load Filtered Items Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearFilteredItems = createAction('[Item/API] Clear Filtered Items')

export const updateCount = createAction('[Item/API] Update Count', props<{ count: number }>())

export const updateOrderHash = createAction('[Item/API] Update Order Hash', props<{ order: string }>())

export const updateOnItemsOrderChange = createAction(
  '[Item/API] Update on Items Order Change',
  props<{ order: string }>(),
)

export const addItem = createAction('[Item/API] Add Item', props<{ item: ItemEntity }>())

export const updateItem = createAction('[Item/API] Update Item', props<{ update: Update<ItemEntity> }>())

export const deleteItemIfExistsInState = createAction(
  '[Item/API] Delete Item if Exists in State',
  props<{ uuid?: string }>(),
)

export const deleteItem = createAction('[Item/API] Delete Item', props<{ uuid: string }>())

export const updateFilters = createAction('[Item/API] Update Filters', props<{ filters: Params }>())

export const removeItems = createAction('[Item/API] Remove Items', props<{ start: number }>())

export const clearItems = createAction('[Item/API] Clear Items')

export const clearItemsState = createAction('[Item/API] Clear Items State')

export const loadItemsFailure = createAction('[Item/API] Load Items Failure', props<{ error: HttpErrorResponse }>())

export const syncItem = createAction(
  '[Item/API] Sync Item',
  props<{
    uuid: string
    onSyncSuccess?: (item: ItemEntity) => Action
  }>(),
)

export const syncItemSuccess = createAction(
  '[Item/API] Sync Item Success',
  props<{ item: ItemEntity; notListLoaded?: boolean }>(),
)

// Resync items actions
export const resyncItemError = createAction(
  '[Item/API] Resync Item Error',
  props<{ error: HttpErrorResponse; uuid?: string }>(),
)

export const resyncItems = createAction('[Item/API] Resync Items', (offset: number, onFocus = false) => ({
  offset,
  onFocus,
}))

export const resyncItemsSuccess = createAction(
  '[Item/API] Resync Items Success',
  props<{
    items: SlimItemEntity[]
    offset: number
    count: number
  }>(),
)

export const resyncItemsError = createAction('[Item/API] Resync Items Error', props<{ error: HttpErrorResponse }>())

export const resyncFilteredItems = createAction(
  '[Item/API] Resync Filtered Items',
  (offset: number, filters: Params, onFocus: boolean = false) => ({
    offset,
    filters,
    onFocus,
  }),
)

export const resyncFilteredItemsSuccess = createAction(
  '[Item/API] Resync Filtered Items Success',
  props<{
    items: SlimItemEntity[]
    offset: number
    count: number
  }>(),
)

export const resyncFilteredItemsError = createAction(
  '[Item/API] Resync Filtered Items Error',
  props<{ error: HttpErrorResponse }>(),
)

export const resyncItemsFirstPage = createAction('[Item/API] Resync Items First Page')

export const resyncFilteredItemsFirstPage = createAction('[Item/API] Resync Filtered Items First Page')

export const resyncItemsCurrentPage = createAction('[Item/API] Resync Items Current Page')

// Popper actions
export const createPopper = createAction('[Item] Create Popper', props<{ data: PopperPayload }>())

export const showPoppers = createAction(
  '[Item] Show/Hide Poppers',
  props<{ showPoppers: boolean; snackBarMessage?: string }>(),
)

export const navigateToItem = createAction(
  '[Item/Page] Navigate to item',
  props<{
    uuid: string
    backPath?: string
    from?: string
    categoryId?: string
  }>(),
)

export const showItemActionSuccess = createAction(
  '[Item/Page] Show Item Action Success',
  props<{ title: string; body: string; messageType?: string }>(),
)

// Stale actions
export const setAllItemsStale = createAction('[Items] Set All Items Stale')

export const setFilteredItemsStale = createAction('[Items] Set Filtered Items Stale')

export const removePageFromStale = createAction('[Items] Remove Page From Stale', props<{ page: number }>())

export const removePagesFromStale = createAction('[Items] Remove Pages From Stale', props<{ start: number }>())

export const removeFilteredPagesFromStale = createAction(
  '[Items] Remove Filtered Pages From Stale',
  props<{ page: number }>(),
)

export const clearStaleItems = createAction('[Item/API] Clear Stale Items')

export const clearStaleFilteredItems = createAction('[Item/API] Clear Stale Filtered Items')

export const redirectItemNotFound = createAction('[Item/API] Redirect Item Not Found')
